import { apiSlice, fetchAllPaginated } from "./api";

const fields = [
  'id', 'title.rendered', 'excerpt.rendered', 'link', 'atf_state',
  'meta.atf_latitude', 'meta.atf_longitude',
].join(',');

export const atfRegionApiSlice = apiSlice.injectEndpoints({
    endpoints: build => ({
      getRegions: build.query({
        queryFn: async (_arg, _queryApi, _extraOptions, baseQuery) => {
            return await fetchAllPaginated(baseQuery, 'atf_region', {_fields: fields});
        },
        providesTags: (result) =>
          result
            ? [
                ...result.map(({ id }) => ({ type: 'atf_region', id })),
                { type: 'atf_region', id: 'LIST' },
              ]
            : [{ type: 'atf_region', id: 'LIST' }],
      }),
      getRegion: build.query({
        query: (id) => {
            return `atf_region/${id}/?_fields=${fields}`
        },
        providesTags: (result, error, id) => [{ type: 'atf_region', id }],
      }),
    }),
    overrideExisting: true,
});

export const { 
    useGetRegionsQuery,
    useGetRegionQuery
} = atfRegionApiSlice;
